<template>
    <div class="row subsectionsCreate-block mt-4">
        <div class="col-xl-12 col-xxl-12 p-lr-0-sm">
            <div class="row multisteps-form">
                <div class="col-sm-12 col-md-7 col-lg-7 col-xl-8 col-xxl-7 p-lr-0-sm">
                    <form class="multisteps-form__form dis-flex flex-column" @submit.prevent>
                        <div class="card p-3 dis-flex flex-column mb-4 multisteps-form__content col-sm-12">
                            <div class="row">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="dis-flex col-12 p-0">
                                        <div class="col-7 p-0 dis-flex flex-m"><i class="uis uis-list-ui-alt mr-2 text-rose"></i>
                                            <h5 class="text-sm-b">Create Subsection</h5>
                                        </div>
                                        <div class="col-5 p-0 ml-auto">
                                            <div class="uploaded-user-icon-show w-full dis-flex flex-m flex-r" v-if="createSubSection.icon">
                                                <small class="text-success txt-italic mr-2">Uploaded icon -</small>
                                                <div class="any-category-user-icon" :style="{'background-image': `url(data:image/png;base64,${createSubSection.icon})`}"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-sm-4 col-md-12 col-lg-4 p-lr-0-sm mb-2">
                                            <label>Category</label>
                                            <div class="pos-relative">
                                                <select class="multisteps-form__input form-control pointer" @change="(event) => {
                                                    createSubSection.category_id = event.target.value
                                                    createSubSection.subcategory_id = null
                                                    createSubSection.section_id = null
                                                }">
                                                    <option :selected="createSubSection.category_id === null" disabled="" hidden>Choose Category</option>
                                                    <option v-for="(thisCategory) in categoriesList" :key="thisCategory.id" :value="thisCategory.id" :selected="createSubSection.category_id == thisCategory.id">{{ componentsGetNormalName(thisCategory.name) }}</option>
                                                </select>
                                                <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 col-md-12 col-lg-4 p-lr-0-sm mb-2" v-if="!(createSubSection.category_id === null)">
                                            <label>Subcategory</label>
                                            <div class="pos-relative">
                                                <select class="multisteps-form__input form-control pointer" @change="(event) => {
                                                    createSubSection.subcategory_id = event.target.value
                                                    createSubSection.section_id = null
                                                }">
                                                    <option :selected="createSubSection.subcategory_id === null" disabled="" hidden>Choose Subcategory</option>
                                                    <template v-for="(thisCategoryArray, thisCategoryArrayKey) in subCategoriesList" :key="thisCategoryArrayKey">
                                                        <template v-if="createSubSection.category_id == thisCategoryArrayKey">
                                                            <option v-for="(thisSubCategory) in thisCategoryArray.data" :key="thisSubCategory.id" :value="thisSubCategory.id" :selected="createSubSection.subcategory_id == thisSubCategory.id">{{ componentsGetNormalName(thisSubCategory.name) }}</option>
                                                        </template>
                                                    </template>
                                                </select>
                                                <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 col-md-12 col-lg-4 p-lr-0-sm mb-2" v-if="!(createSubSection.subcategory_id === null)">
                                            <label>Section</label>
                                            <div class="pos-relative">
                                                <select class="multisteps-form__input form-control pointer" @change="createSubSection.section_id = $event.target.value">
                                                    <option :selected="createSubSection.section_id === null" disabled="" hidden>Choose Section</option>
                                                    <template v-for="(thisSubCategoryArray, thisSubCategoryArrayKey) in sectionsList" :key="thisSubCategoryArrayKey">
                                                        <template v-if="createSubSection.subcategory_id == thisSubCategoryArrayKey">
                                                            <option v-for="(thisSection) in thisSubCategoryArray.data" :key="thisSection.id" :value="thisSection.id" :selected="createSubSection.section_id == thisSection.id">{{ componentsGetNormalName(thisSection.name) }}</option>
                                                        </template>
                                                    </template>
                                                </select>
                                                <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-8 col-lg-7 p-lr-0-sm mt-3">
                                            <div class="col-sm-12 p-0 dis-flex">
                                                <div class="col-9 col-lg-10 p-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label>Name</label>
                                                        <div class="btn small-form-btn fs-10 pointer" title="Translations Languages">
                                                            <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="createSubSection.selected_lang = $event.target.value">
                                                                <option v-for="(thisName, thisNameKey) in createSubSection.name" :key="thisNameKey" :value="thisNameKey" :selected="createSubSection.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <template v-for="(thisName, thisNameKey) in createSubSection.name" :key="thisNameKey">
                                                        <input v-if="createSubSection.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="SubSection Name" v-model="createSubSection.name[thisNameKey]">
                                                    </template>
                                                </div>
                                                <div class="col-3 col-lg-3 dis-flex flex-column flex-m pr-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label class="mb-0">Icon</label>
                                                    </div>
                                                    <div class="pick-an-icon mt-auto pointer">
                                                        <label class="pointer" for="categoryIcon">
                                                            <i class="uis uis-scenery mr-2 fs-25 pointer"></i>
                                                        </label>
                                                        <input accept="image/png, image/jpeg" type="file" @change="uploadSubSectionIcon($event)" id="categoryIcon">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4 col-lg-5 dis-flex flex-column mt-auto p-0">
                                            <div class="col-sm-12 p-lr-0-sm dis-flex">
                                                <button class="btn button-create-atrb-btn ml-auto" type="button" title="Create Subsection" :disabled="(!componentsAttributesIsAllNamesLength(createSubSection.name, 3) || createSubSection.category_id === null || createSubSection.subcategory_id === null || createSubSection.section_id === null)" @click="createNewSubSection()">Create</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-sm-12 col-md-5 col-lg-5 col-xl-4 col-xxl-5 p-lr-0-sm">
                    <div class="card multisteps-form__content p-3 dis-flex flex-column mb-4 max-h-c100-210vh">
                        <div class="dis-flex flex-m flex-sb col-12 p-0 mb-3">
                            <div class="dis-flex flex-m">
                                <i class="uis uis-list-ui-alt mr-2 text-rose"></i>
                                <h5 class="text-sm-b">All Subsections</h5>
                            </div>
                            <small class="text-rose txt-italic">Created</small>
                        </div>
                        <div class="content-crds-messages-scroll">
                            <template v-for="(thisSectionArray, thisSectionId) in subSectionsList" :key="thisSectionId">
                                <div class="row mb-2" v-for="thisSubSection in thisSectionArray.data" :key="thisSubSection.id">
                                    <div class="col-sm-12 p-lr-0-sm">
                                        <div class="bg-white-list">
                                            <div class="dis-flex flex-m flex-sb">
                                                <div class="dis-flex flex-m">
                                                    <div class="mr-2 any-category-user-icon" v-if="thisSubSection.icon" :style="{'background-image': `url(data:image/png;base64,${thisSubSection.icon})`}"></div>
                                                    <h5 class="text-sm-b">{{ componentsGetNormalName(thisSubSection.name) }}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import componentsGetNormalName from '@/mixins/componentsGetNormalName.js'

export default {
    mixins: [componentsGetNormalName],
    props: {
        categoriesList: {
            type: Array,
            required: true
        },
        subCategoriesList: {
            type: Object,
            required: true
        },
        sectionsList: {
            type: Object,
            required: true
        },
        subSectionsList: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            createSubSection: {
                selected_lang: 'en',
                category_id: null,
                subcategory_id: null,
                section_id: null,
                name: {},
                icon: null,
            }
        }
    },
    methods: {
        createNewSubSection: function() {
            let thisNewSubSectionData = JSON.parse(JSON.stringify(this.createSubSection))
            let newSubSectionData = {
                id: (Math.floor(Math.random() * 100000000) + 100000),
                category_id: thisNewSubSectionData.category_id,
                subcategory_id: thisNewSubSectionData.subcategory_id,
                section_id: thisNewSubSectionData.section_id,
                name: thisNewSubSectionData.name,
                icon: thisNewSubSectionData.icon,
            }
            socket.emit('categories:createSubSection', newSubSectionData, (success) => {
                this.$emit('updateSubSectionsList')
            })
            if (this.subSectionsList.hasOwnProperty(`${thisNewSubSectionData.subcategory_id}`)) {
                this.subSectionsList[`${thisNewSubSectionData.subcategory_id}`].data.push(newSubSectionData)
            } else {
                this.subSectionsList[`${thisNewSubSectionData.subcategory_id}`] = {
                    opened: false,
                    data: [newSubSectionData]
                }
            }

            this.createSection.selected_lang = 'en'
            this.createSection.icon = null
            this.createSection.category_id = null
            this.createSection.subcategory_id = null
            for (const key in this.createSection.name) {
                this.createSection.name[key] = ''
            }
        },
        componentsAttributesIsAllNamesLength: function(thisNameObj, minLength) {
            let allNameIsWithMinLength = true

            for (const key in thisNameObj) {
                const thisName = thisNameObj[key]
                if (thisName.length < minLength) {
                    allNameIsWithMinLength = false
                    break
                }
            }

            return allNameIsWithMinLength
        },
        uploadSubSectionIcon: function(thisEvent) {
            let thisVue = this
            for (const key in thisEvent.target.files) {
                const thisNewImage = thisEvent.target.files[key]
                if (typeof thisNewImage != 'object') continue;
                else if (key == 'length') continue;
                else if (thisNewImage.type.indexOf('image') != 0) continue;

                const reader = new FileReader();
                reader.onload = function() {
                    const base64 = this.result.replace(/.*base64,/, '');
                    thisVue.createSubSection.icon = base64
                };
                reader.readAsDataURL(thisNewImage);
                break;
            }
            thisEvent.target.value = ''
        }
    },
    watch: {
        '$store.state.languages': {
            handler: function(newLangObj, oldLangObj) {
                for (const key in newLangObj) {
                    if (!this.createSubSection.name.hasOwnProperty(key)) {
                        this.createSubSection.name[key] = ''
                    }
                }
            },
            deep: true
        }
    },
    mounted: function() {
        this.$emit('updateSubSectionsList')

        for (const key in this.$store.state.languages) {
            if (!this.createSubSection.name.hasOwnProperty(key)) {
                this.createSubSection.name[key] = ''
            }
        }
    }
}
</script>

<style>

</style>